import { CATEGORY_QUERY_PARAMS } from "../constants";
import { CategoryFilterOption } from "../types";

const categoryLevelOrder = CATEGORY_QUERY_PARAMS as unknown as string[];

export const stripCategoryDeeperThanAnchor = (
  flat: CategoryFilterOption[],
  anchor: CategoryFilterOption
): CategoryFilterOption[] => {
  const ai = categoryLevelOrder.indexOf(String(anchor.queryParam));
  if (ai === -1) return flat;
  const prefix = String(anchor.key);
  return flat.filter(o => {
    const oi = categoryLevelOrder.indexOf(String(o.queryParam));
    if (oi <= ai) return true;
    const k = String(o.key);
    if (k === prefix) return true;
    return !k.startsWith(`${prefix}+`);
  });
};

export const dropShallowRowsCoveredByDeeper = (
  flat: CategoryFilterOption[]
): CategoryFilterOption[] => {
  const params = CATEGORY_QUERY_PARAMS as unknown as string[];
  let out = [...flat];
  for (let i = 0; i < params.length; i++) {
    const shallow = params[i];
    const deeperKeys = params
      .slice(i + 1)
      .flatMap(p =>
        out.filter(o => o.queryParam === p).map(o => String(o.key))
      );
    if (deeperKeys.length === 0) continue;
    out = out.filter(o => {
      if (o.queryParam !== shallow) return true;
      const k = String(o.key);
      return !deeperKeys.some(d => d === k || d.startsWith(`${k}+`));
    });
  }
  return out;
};
